<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="ion-text-left">
      <ion-button  (click)="dismiss()">
        <ion-icon name='close'></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>
      Search Sale
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]='searchForm'>
    <ion-searchbar
      #searchBar
      type="search"
      placeholder="Search client"
      animated="true"
      formControlName="searchField"
      show-cancel-button="focus"
      [(ngModel)]="searchTerm"
      >
    </ion-searchbar>

    <ion-button color="primary" expand="block" (click)="searchSale()">
      Run Search
    </ion-button>
  </form>
</ion-content>
